import { IRenderer } from '../renderTree.types';
import styles from './EscapeRenderer.styles.m.css';

export const EscapeRenderer: IRenderer = ({ children }) => {
  return <span className={styles.container}>{children}</span>;
};
